<script lang="ts">
  import useActiveCategory from '../hooks/use-active-category'
  import Button, { COLOR } from './Button.svelte'
  import useFilter from '../hooks/use-filter'
  import type { Filter } from '../global'
  import NavText from './NavText.svelte'
  import Badge from './Badge.svelte'
  import Image from './Image.svelte'
  import cx from 'classnames'

  export let category: Filter.Category

  const { id, countSelected, nav } = category
  const { activeId, setActiveId } = useActiveCategory()
  const { isSimpleView } = useFilter()
  const onClick = () => {
    setActiveId(id)
    // tag is a function used to log some actions in smartlook
    // @ts-ignore
    window.tag && window.tag('hotelform', id)
  }
</script>

<li class="filter-nav-item flex-1" class:opacity-80={$activeId === id}>
  <Button color={isSimpleView ? COLOR.LIGHT : COLOR.PRIMARY} class="z-10 w-full" on:click={onClick}>
    <NavText {nav} />
    {#if countSelected > 0}
      <Badge>{countSelected}</Badge>
    {/if}
    <Image class={cx('ml-2', { invert: isSimpleView })} src="/share/img/sipka_velka_B.svg" />
  </Button>
</li>
